var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcSiteDLayer(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "ic-site-d-layer-a",
    x1: "100%",
    x2: "0%",
    y1: "30.493%",
    y2: "50%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#A4B7D5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ic-site-d-layer-b",
    x1: "91.177%",
    x2: "0%",
    y1: "90.668%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#F9FAFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "28.631%",
    stopColor: "#BBC5D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "79.795%",
    stopColor: "#BBC5D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#A4B7D5"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E7EEFB",
    d: "M24.1213203,4.90811691 L30.0772351,10.8628061 C29.0875874,10.614088 27.9958446,10.8767384 27.2218254,11.6507576 L27.2218254,11.6507576 L13.0796898,25.7928932 C11.9081169,26.9644661 11.9081169,28.863961 13.0796898,30.0355339 L13.0796898,30.0355339 L25.1284373,42.0844373 L24.1213203,43.0918831 C22.9497475,44.263456 21.0502525,44.263456 19.8786797,43.0918831 L2.90811691,26.1213203 C1.73654403,24.9497475 1.73654403,23.0502525 2.90811691,21.8786797 L19.8786797,4.90811691 C21.0502525,3.73654403 22.9497475,3.73654403 24.1213203,4.90811691 Z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    x: 17.343,
    y: 15.914,
    stroke: "url(#ic-site-d-layer-a)",
    strokeWidth: 2,
    rx: 3,
    transform: "rotate(45 29.343 27.914)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "url(#ic-site-d-layer-b)",
    strokeLinecap: "square",
    strokeWidth: 2,
    d: "M21.5,19.5 L26.5356445,24.5356445 M32.5406494,30.5406494 L38.0404053,36.0404053"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    x: 25.5,
    y: 23.5,
    stroke: "#BBC5D9",
    strokeWidth: 2,
    rx: 1,
    transform: "rotate(45 29.5 27.5)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSiteDLayer);
export default __webpack_public_path__ + "static/media/ic-site-d-layer.381f25c48160fe9e0ac5bf45c0716196.svg";
export { ForwardRef as ReactComponent };